// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"978b50b2","239":"e19a5549","453":"dea11a56","455":"abcd5e2d"}[chunkId] + ".chunk.js";
};